import styled from "styled-components"
import Grid from "@mui/material/Grid"

export const Container = styled(Grid)`
  background: #ffffff77;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
`
